export default __webpack_public_path__ + "static/shawn2-1a77400a21dc5aa22d9483b5da056a04.png";